/**
 * @generated SignedSource<<5796b1c5edb73f0f3e12cbab8b4dedc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EtgSettings_settings$data = {
  readonly etg: {
    readonly fullLogContext: boolean | null;
    readonly incrementalBatchSize: number | null;
    readonly incrementalImport: boolean | null;
    readonly key: string | null;
    readonly keyId: string | null;
    readonly maxRateUpdateFrequency: number | null;
    readonly rateUpdatesEnabled: boolean | null;
  } | null;
  readonly " $fragmentType": "EtgSettings_settings";
};
export type EtgSettings_settings$key = {
  readonly " $data"?: EtgSettings_settings$data;
  readonly " $fragmentSpreads": FragmentRefs<"EtgSettings_settings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EtgSettings_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EtgSettings",
      "kind": "LinkedField",
      "name": "etg",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "keyId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "incrementalImport",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "incrementalBatchSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullLogContext",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rateUpdatesEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxRateUpdateFrequency",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Settings",
  "abstractKey": null
};

(node as any).hash = "d4fa3cc959765327919ae48811594f0b";

export default node;
